// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"ce9f06c3","380":"996dae3a"}[chunkId] + ".chunk.css";
};